import script from "./competitor.vue?vue&type=script&setup=true&lang=js"
export * from "./competitor.vue?vue&type=script&setup=true&lang=js"

import "./competitor.vue?vue&type=style&index=0&id=58605ede&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58605ede"]])

export default __exports__